module.exports = __webpack_public_path__ + "image-e1486859061c.png";